/*** IMPORTS FROM imports-loader ***/
var define = false;

/*** IMPORTS FROM imports-loader ***/


'use strict';

class WrapperConfig {

  static create(SuiteAPI) {
    if (!SuiteAPI.config) {
      throw new Error('No Config found in SuiteAPI.');
    }

    return SuiteAPI.config;
  }
}

module.exports = WrapperConfig;




/*** EXPORTS FROM exports-loader ***/



/** WEBPACK FOOTER **
 ** ./connect/wrapper/config.js
 **/